"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// deps
var react_1 = __importStar(require("react"));
// internal-deps
var Text_1 = require("@swiggy-private/dls-web-core/dist/components/Text");
var Button_1 = require("@swiggy-private/dls-web-core/dist/components/Button");
var arrowBack_1 = require("@swiggy-private/dls-web-icons/dist/web/generic/arrowBack");
var GenericIconWeb_1 = require("@swiggy-private/dls-web-icons/dist/GenericIconWeb");
var Image_1 = require("@swiggy-private/dls-web-core/dist/components/Image");
// constants
var constants_1 = require("./constants");
// styles components
var styles_1 = require("./styles");
var ErrorPage = function (_a) {
    var onBackClick = _a.onBackClick, onCtaClick = _a.onCtaClick, title = _a.title, message = _a.message, ctaText = _a.ctaText;
    return (react_1.default.createElement(styles_1.ErrorContainer, null,
        react_1.default.createElement(styles_1.MarginWrapper, null, typeof onBackClick === "function" && (react_1.default.createElement(styles_1.BackButton, { onClick: onBackClick, "data-testid": constants_1.TEST_IDS.BACK_ICON },
            react_1.default.createElement(GenericIconWeb_1.GenericIcon, { Icon: arrowBack_1.Svg20 })))),
        react_1.default.createElement(styles_1.ErrorContent, null,
            react_1.default.createElement(styles_1.ErrorImage, null,
                react_1.default.createElement(Image_1.Image, { fit: "fill", background: "background_Primary", cloudinaryId: constants_1.ERROR_IMAGE_ID_UX4, alt: "Error Page" })),
            react_1.default.createElement(styles_1.ErrorTextContent, null,
                react_1.default.createElement(Text_1.Text, { variant: "V2.heading2.neutral.bold", color: "text_Highest_Emphasis" }, title !== null && title !== void 0 ? title : constants_1.DEFAULT_ERROR_MSG_DETAILS.TITLE),
                react_1.default.createElement(styles_1.ErrorMsgWrapper, null,
                    react_1.default.createElement(Text_1.Text, { variant: "V2.body1.neutral.regular", color: "text_High_Emphasis" }, message !== null && message !== void 0 ? message : constants_1.DEFAULT_ERROR_MSG_DETAILS.MESSAGE))),
            react_1.default.createElement(styles_1.CtaWrapper, null,
                react_1.default.createElement(Button_1.Button, { onClick: onCtaClick, variant: "secondary", "data-testid": constants_1.TEST_IDS.CTA }, ctaText !== null && ctaText !== void 0 ? ctaText : constants_1.DEFAULT_ERROR_MSG_DETAILS.CTA)))));
};
exports.default = (0, react_1.memo)(ErrorPage);
